export function classificationRequestMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'code' in error) {
    const messages: Record<string, string> = {
      not_configured: 'Save your instructions and permissions before continuing.',
      missing_scopes:
        'Reconnect this mailbox with the permissions required by your selected actions.',
      reconnect_required: 'Reconnect this mailbox before continuing.',
      target_missing:
        'A selected label or folder is missing. Refresh targets and choose an available one.',
      mailbox_already_controlled:
        'This mailbox is already processing on another connection.',
      legacy_work_running:
        'Previous email processing must finish before switching to classification.',
      gate_unavailable:
        'Automatic actions are awaiting service readiness. Try again later.',
      activation_unavailable:
        'Automatic actions are awaiting service readiness. Try again later.',
    }
    if (typeof error.code === 'string' && messages[error.code])
      return messages[error.code]!
  }
  if (error && typeof error === 'object' && 'status' in error) {
    switch (error.status) {
      case 409:
        return 'The saved setup changed. Review the latest version before trying again.'
      case 401:
      case 403:
        return 'Access could not be confirmed. Sign in again or reconnect this mailbox.'
      case 404:
        return 'This mailbox or message is no longer available. Refresh the mailbox and try again.'
      case 422:
        return 'Some settings could not be accepted. Review your instructions and selected permissions.'
      case 429:
        return 'The request limit has been reached. Wait a moment, then try again.'
      case 503:
        return 'The service is unavailable. Try again in a moment.'
    }
  }
  return 'The request could not complete. Your edits are still here. Try again.'
}
